const SMS_DONT_ASK_UNTIL_KEY = 'sms_dont_ask_until';

function getCurrentYearMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function shouldOfferSms(): boolean {
  try {
    const stored = localStorage.getItem(SMS_DONT_ASK_UNTIL_KEY);
    if (!stored) return true;
    const current = getCurrentYearMonth();
    return current > stored;
  } catch (err) {
    console.error('[smsConfirmStorage] shouldOfferSms failed:', err);
    throw err instanceof Error ? err : new Error(String(err));
  }
}

export function markDontAskUntilNextMonth(): void {
  try {
    localStorage.setItem(SMS_DONT_ASK_UNTIL_KEY, getCurrentYearMonth());
  } catch (err) {
    console.error('[smsConfirmStorage] markDontAskUntilNextMonth failed:', err);
    throw err instanceof Error ? err : new Error(String(err));
  }
}
